import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Search from '@mui/icons-material/Search';
import { Link as RouterLink } from 'react-router-dom';

/**
 * The looking glass that opens an entity's own page in a new tab — the convention Zuul users know
 * from the classic screens. A new tab, so whatever is being built here keeps its unsaved state.
 * It stops its click and press from reaching the row around it, so it never opens a popover or
 * starts a drag.
 */
export default function EntityLink({
  to,
  label,
  size = 'small',
}: {
  to: string;
  label: string;
  size?: 'small' | 'medium';
}) {
  const stop = (event: React.SyntheticEvent) => event.stopPropagation();
  return (
    <Tooltip title={label}>
      <IconButton
        component={RouterLink}
        to={to}
        target='_blank'
        rel='noopener noreferrer'
        data-external-link='true'
        aria-label={label}
        size={size}
        onClick={stop}
        onMouseDown={stop}
        onKeyDown={stop}
        sx={{ color: 'info.main', flex: '0 0 auto' }}
      >
        <Search fontSize='small' />
      </IconButton>
    </Tooltip>
  );
}

/* Where each kind of entity is configured. */
export const offerPath = (offerId: number) => `/campaigns/offertable/offer/${offerId}`;
export const offerBlockPath = (offerBlockId: number) => `/campaigns/offerblocks/${offerBlockId}`;
export const offerActionPath = (offerActionId?: number | null) =>
  offerActionId ? `/campaigns/offeractions/${offerActionId}` : '/campaigns/offeractions';
export const layoutPath = (layoutId: number) => `/content/layouts/${layoutId}`;
export const containerPath = (containerId: number) => `/content/containers/${containerId}`;
/** Dynamic offer sections have no page of their own; their list is the closest. */
export const dynamicOfferSectionsPath = '/campaigns/dynamic-offer-sections';
